import { apiGet } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

import { IKnmViolationType } from '../interfaces/IKnmViolationType';

export async function fetchKnmViolationTypes(): Promise<IKnmViolationType[]> {
  return apiGet<IKnmViolationType[]>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/knm-violation-types`);
}
